var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27,2H5C3.3457031,2,2,3.3457031,2,5v22c0,1.6542969,1.3457031,3,3,3h22c1.6542969,0,3-1.3457031,3-3V5 C30,3.3457031,28.6542969,2,27,2z M5,4h22c0.5517578,0,1,0.4482422,1,1v11.5859375L24.4140625,13 C23.125,11.7109375,20.875,11.7109375,19.5859375,13L13,19.5859375L10.4140625,17C9.125,15.7109375,6.875,15.7109375,5.5859375,17 L4,18.5859375V5C4,4.4482422,4.4482422,4,5,4z M27,28H5c-0.5517578,0-1-0.4482422-1-1v-5.5859375l3-3 c0.5351562-0.5332031,1.4648438-0.5332031,2,0l3.2929688,3.2929688C12.4882812,21.9023438,12.7441406,22,13,22 s0.5117188-0.0976562,0.7070312-0.2929688L21,14.4140625c0.5351562-0.5332031,1.4648438-0.5332031,2,0l5,5V27 C28,27.5517578,27.5517578,28,27,28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,14c2.2060547,0,4-1.7939453,4-4s-1.7939453-4-4-4s-4,1.7939453-4,4S7.7939453,14,10,14z M10,8 c1.1025391,0,2,0.8974609,2,2s-0.8974609,2-2,2s-2-0.8974609-2-2S8.8974609,8,10,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSmall);
export default __webpack_public_path__ + "static/media/image--small.4dc116cc7eaa18b5b19b85b351bcd1f2.svg";
export { ForwardRef as ReactComponent };